import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { FooterButtons } from '../../../shared/components/Modals/FooterButtons';
import classNames from 'classnames';

export function TextDisplayModal({
  isOpen,
  onClose,
  title = 'Message',
  content = '',
  modalSize = 'md',
  modalClassName = '',
  contentClassName = '',
  textClassName = '',
  onSave = undefined,
}) {
  return (
    <Modal
      isOpen={isOpen}
      size={modalSize}
      className={classNames(
        'nested-modal message-modal model-form',
        modalClassName,
      )}
    >
      <ModalHeader>
        <h3>{title}</h3>
      </ModalHeader>
      <ModalBody>
        <div className={classNames('message-container', contentClassName)}>
          <p className={classNames('message-content', textClassName)}>
            {content}
          </p>
        </div>

        <FooterButtons
          onClose={onClose}
          showSaveButton={!!onSave}
          onSave={onSave}
        />
      </ModalBody>
    </Modal>
  );
}
